import { render, staticRenderFns } from "./AppDepartmentReviewsBlock.vue?vue&type=template&id=63e4ae69"
import script from "./AppDepartmentReviewsBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentReviewsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports